import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["name", "user"]

  nameChanged() {
    if (this.userTarget.tomselect) {
      this.userTarget.tomselect.clear(true)
    } else {
      this.userTarget.value = ""
    }
  }

  userChanged() {
    const id = this.userTarget.value
    if (!id) return

    const option = this.userTarget.tomselect?.options[id]
    if (option?.name) this.nameTarget.value = option.name
  }
}
